import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import styled from 'styled-components';
import dayjs, { Dayjs } from 'dayjs';
import { TextField } from '@mui/material';
import { useEffect, useState } from 'react';

const CustomStyleDatePicker = styled(TimePicker)`
  & label {
    color: #888;
  }
  & label.Mui-focused {
    color: #888;
  }
  & .notchedOutline {
    border-color: #888;
  }
  & .MuiOutlinedInput-root {
    color: #333;
    & fieldset {
      border-color: #888;
    }
    &.Mui-focused fieldset {
      border-color: #888;
    }
    &:hover fieldset {
      border-color: #888;
    }
  }
`;

export default function CustomTimePicker({
  label,
  size,
  initValue,
  onChange,
}: { label: string; size?: 'medium' | 'small'; initValue?: string; onChange?: any }) {
  const [val, setVal] = useState<Dayjs>();
  const handleChange = (value: Dayjs) => {
    setVal(value);
    onChange && onChange(value !== null ? value.format('HH:mm') : null);
  };

  useEffect(() => {
    if (initValue) {
      const now = new Date();
      const [hour, min] = initValue.split(':');
      now.setHours(Number(hour), Number(min));
      setVal(dayjs(now));
    } else {
      const now = new Date();
      now.setHours(7, 0);
      setVal(dayjs(now));
    }
  }, [initValue]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <CustomStyleDatePicker
        sx={{ svg: { color: '#888' }, width: '11rem' }}
        views={['hours', 'minutes']}
        slotProps={{
          field: { clearable: true },
          textField: { size: size ? size : 'medium', label, slotProps: { inputLabel: { shrink: true } } },
        }}
        onChange={handleChange}
        value={val}
      />
    </LocalizationProvider>
  );
}
